import { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Toast } from './Toast';
import { useAppStore } from '../store';

const navigation = [
  ['/', '⌂', 'Dashboard'], ['/markt', '▦', 'Markt'], ['/arbitrage', '⇄', 'Arbitrage'], ['/crafting', '⚒', 'Crafting'], ['/refining', '◫', 'Refining'],
  ['/farming', '♧', 'Farming'], ['/verzauberung', '✦', 'Verzauberung'], ['/scanner', '⌁', 'Scanner'], ['/preisverlauf', '⌇', 'Preisverlauf'], ['/favoriten', '☆', 'Favoriten'], ['/einstellungen', '⚙', 'Einstellungen'],
] as const;

export function Layout() {
  const [open, setOpen] = useState(false);
  const server = useAppStore((state) => state.settings.server);
  return <div className="app-shell">
    <aside className={open ? 'open' : ''}>
      <div className="brand"><div className="brand-mark"><span>Æ</span></div><div><strong>Albion</strong><small>ECONOMY HUB</small></div><button className="mobile-close" onClick={() => setOpen(false)}>×</button></div>
      <nav>{navigation.map(([path, icon, label]) => <NavLink end={path === '/'} to={path} key={path} onClick={() => setOpen(false)}><span>{icon}</span>{label}</NavLink>)}</nav>
      <div className="sidebar-status"><span className="status-dot" /><div><strong>{server[0]?.toUpperCase()}{server.slice(1)} Server</strong><small>Albion Data Project</small></div></div>
    </aside>
    {open && <button className="backdrop" onClick={() => setOpen(false)} aria-label="Navigation schließen" />}
    <div className="app-content"><div className="mobile-bar"><button onClick={() => setOpen(true)} aria-label="Navigation öffnen">☰</button><strong>Albion Economy Hub</strong><span className="status-dot" /></div><main><Outlet /></main><footer>Albion Economy Hub ist nicht mit Sandbox Interactive verbunden. Marktdaten stammen von Spielern und können fehlen oder veraltet sein. Created by RaptorZ</footer></div>
    <Toast />
  </div>;
}
